import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addGradeMaster,
  addGradePolicy,
  addPolicyMaster,
  deleteGradePolicy,
  getBudgetsData,
  getCurrencies,
  getGradeMastersData,
  getGradePolicyData,
  getOrgUnitsData,
  getPolicyMasterData,
  updateGradeMaster,
  updateGradePolicy,
  updatePolicyMaster,
} from "../repository/GradeMasterRepository";
import { showToast } from "../../../../utils/toastUtils";

//Get Grade Masters Data
export const useGradeMastersData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GRADE_MASTERS"],
    queryFn: getGradeMastersData,
    enabled: enable,
    retry: false,
  });
};

//Get Budgets Data
export const useBudgetsData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["BUDGETS"],
    queryFn: getBudgetsData,
    enabled: enable,
    retry: false,
  });
};

// Add Grade Master
export const useAddGradeMaster = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addGradeMaster,
    onSuccess: (data) => {
      showToast.success("Grade Master Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GRADE_MASTERS"] });
      // <Loader />
    },
    onError: (error) => {
      showToast.warning("Failed to Add Grade Master!");
    },
  });
};

// Update Grade Master
export const useUpdateGradeMaster = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateGradeMaster,
    onSuccess: (data) => {
      showToast.success("Update Grade Master Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GRADE_MASTERS"] });
    },
    onError: (error) => {
      showToast.warning("Failed to Add Grade Master!");
    },
  });
};

// Get Policy Master
//getPolicyMasterData

export const usePolicyMasterData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["POLICY_MASTERS"],
    queryFn: getPolicyMasterData,
    enabled: enable,
    retry: false,
  });
};

// Get Org Unit
//getOrgUnitsData

export const useGetOrgUnitsData = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["ORG_UNITS"],
    queryFn: getOrgUnitsData,
    enabled: enable,
    retry: false,
  });
};

// Get Grade Policy Data
export const useGetGradePolicyData = ({
  enable = false,
  params = {},
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GRADE_POLICY", params],
    queryFn: () => getGradePolicyData(params),
    enabled: enable,
    retry: false,
  });
};

// Get Currencies
export const useGetCurrencies = ({
  enable = false,
  params = {},
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["GET_CURRENCIES"],
    queryFn: getCurrencies,
    enabled: enable,
    retry: false,
  });
};

//addPolicyMaster
export const useAddPolicyMaster = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addPolicyMaster,
    onSuccess: (data) => {
      showToast.success("New Policy Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["POLICY_MASTERS"] });
      queryClient.invalidateQueries({ queryKey: ["GRADE_POLICY"] });
      // <Loader />
    },
    onError: (error: any) => {
      showToast.warning(error);
    },
  });
};

// Update Policy Master
export const useUpdatePolicyMaster = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePolicyMaster,
    onSuccess: (data) => {
      showToast.success("Update Policy Successfully!");
      queryClient.invalidateQueries({ queryKey: ["POLICY_MASTERS"] });
      queryClient.invalidateQueries({ queryKey: ["GRADE_POLICY"] });
    },
    onError: (error: any) => {
      showToast.warning(error);
    },
  });
};

// Add Grade Policy
//addGradePolicy
export const useAddGradePolicy = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addGradePolicy,
    onSuccess: (data) => {
      showToast.success("Grade Policy Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GRADE_POLICY"] });
      queryClient.invalidateQueries({ queryKey: ["POLICY_MASTERS"] });
      // <Loader />
    },
    onError: (error: any) => {
      showToast.warning(error);
    },
  });
};

export const useUpdateGradePolicy = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateGradePolicy,
    onSuccess: (data) => {
      showToast.success("Update Grade Policy  Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GRADE_POLICY"] });
      queryClient.invalidateQueries({ queryKey: ["POLICY_MASTERS"] });
      // <Loader />
    },
    onError: (error: any) => {
      showToast.warning(error);
    },
  });
};

// Delete Grade Policy
export const useDeleteGradePolicy = ({
  params = {},
}: { params?: Record<string, any> } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => deleteGradePolicy(params), // Call API with only `id`
    onSuccess: () => {
      showToast.success("Grade Policy Deleted Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GRADE_POLICY"] }); // Refresh data
      queryClient.invalidateQueries({ queryKey: ["POLICY_MASTERS"] }); // Refresh data
    },
    onError: (error: any) => {
      showToast.warning(error.message || "Failed to delete grade policy");
    },
  });
};
